export const isGuaranteesAdministratorRoute = (path: string): boolean =>
  path.startsWith('/guarantees/administrator');

export const isGuaranteesUdbtfApplicationStep = (path: string): boolean =>
  /^\/guarantees\/administrator\/application\/[^/]+\/(?:step3|udbtf-approval-letter|udbtf-guarantee-scan-copy|internal-approval-letter\/[^/]+)$/.test(
    path
  );

export const isGuaranteesUakdoApplicationStep = (path: string): boolean =>
  /^\/guarantees\/administrator\/application\/[^/]+\/uakdo-control$/.test(path);

export const isGuaranteesUakdoControllerApplicationStep = (path: string): boolean =>
  /^\/guarantees\/administrator\/application\/[^/]+\/uakdo-controller-control$/.test(path);

export const isGuaranteesUsapokApplicationStep = (path: string): boolean =>
  /^\/guarantees\/administrator\/application\/[^/]+\/usapok-approval$/.test(path);

export const resolveGuaranteesSignInPath = (path: string): string =>
  isGuaranteesAdministratorRoute(path) ? '/manager/sign-in' : '/sign-in';
